package com.tregz.tremenz.ui.route

actual fun routeSet(): List<RouteKey> = RouteKey.entries
